import { useTranslation } from 'react-i18next';

interface AgreementSection {
  readonly title: string;
  readonly clauses: ReadonlyArray<string>;
}

interface AgreementClosing {
  readonly title: string;
  readonly lines: ReadonlyArray<string>;
}

const AgreementIntro = ({ paragraphs }: { readonly paragraphs: ReadonlyArray<string>; }) => (
  <section className="space-y-4">
    {paragraphs.map((paragraph, index) => (
      <p key={`intro-${index}`} className="text-base leading-relaxed">
        {paragraph}
      </p>
    ))}
  </section>
);

const AgreementSections = ({ sections }: { readonly sections: ReadonlyArray<AgreementSection>; }) => (
  <section className="space-y-10">
    {sections.map(section => (
      <article key={section.title} className="space-y-4">
        <h2 className="text-2xl font-semibold">{section.title}</h2>
        <ul className="space-y-2 list-disc list-inside">
          {section.clauses.map(clause => (
            <li key={clause} className="text-base leading-relaxed">
              {clause}
            </li>
          ))}
        </ul>
      </article>
    ))}
  </section>
);

const AgreementClosingSection = ({ closing }: { readonly closing: AgreementClosing; }) => (
  <section className="space-y-2">
    <h2 className="text-2xl font-semibold">{closing.title}</h2>
    <address className="not-italic space-y-1 text-base leading-relaxed">
      {closing.lines.map(line => (
        <div key={line}>{line}</div>
      ))}
    </address>
  </section>
);

const OfertaPage = () => {
  const { t } = useTranslation('oferta');
  const intro = t('intro', { returnObjects: true }) as ReadonlyArray<string>;
  const sections = t('sections', { returnObjects: true }) as ReadonlyArray<AgreementSection>;
  const closing = t('closing', { returnObjects: true }) as AgreementClosing;

  return (
    <div className="flex flex-col items-center min-h-screen bg-brand-background text-brand-brown p-4 pt-8 dark:bg-gray-900 dark:text-gray-300">
      <div className="w-full max-w-4xl space-y-8">
        <header className="space-y-2 text-center">
          <h1 className="text-3xl font-semibold text-brand-green dark:text-gray-100">
            {t('title')}
          </h1>
          <p className="text-xl font-medium dark:text-gray-100">{t('subtitle')}</p>
          <p className="text-muted-foreground dark:text-gray-300">{t('lead')}</p>
        </header>
        <AgreementIntro paragraphs={intro} />
        <AgreementSections sections={sections} />
        <AgreementClosingSection closing={closing} />
      </div>
    </div>
  );
};

export default OfertaPage;
